/* eslint-disable react/prop-types */
import React from "react";
import "../../assets/styles/App.css";
import { Button, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getDevicesForSite,
  removeDeviceFromSiteForService
} from "../../constants/endpoints";
import { getAuthenticatedData, putAuthenticatedData } from "../../utils/async";
import { withTranslation } from "react-i18next";
import { T_SERVICE } from "../../constants/translations";

/**
 * Modal that lists the devices currently linked to a site and allows a SERVICE
 * user to unlink (de-link) a device from that site. Only rendered for SERVICE users.
 *
 * @component
 */
class CustomDevicesModal extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.i18n = props.i18n;

    this.state = {
      isLoaded: false,
      devices: [],
      confirmingDeviceId: null,
      unlinkingDeviceId: null
    };

    this.fetchDevices = this.fetchDevices.bind(this);
    this.handleUnlinkClick = this.handleUnlinkClick.bind(this);
  }

  componentDidMount() {
    this.fetchDevices();
  }

  fetchDevices() {
    this.setState({ isLoaded: false });
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getDevicesForSite +
        "/" +
        this.props.siteId
    ).then(
      result => {
        this.setState({
          devices: result?.data || [],
          isLoaded: true,
          confirmingDeviceId: null,
          unlinkingDeviceId: null
        });
      },
      () => {
        this.setState({ isLoaded: true });
      }
    );
  }

  handleUnlinkClick(deviceId) {
    // First click arms the confirmation, second click on the same device unlinks.
    if (this.state.confirmingDeviceId !== deviceId) {
      this.setState({ confirmingDeviceId: deviceId });
      return;
    }

    this.setState({ unlinkingDeviceId: deviceId });
    putAuthenticatedData(
      sessionStorage.getItem("domain") +
        removeDeviceFromSiteForService +
        "/" +
        deviceId,
      {}
    )
      .then(result => {
        if (result.status === 200) {
          toast.success(this.t(T_SERVICE.toast.deviceUnlinkedSuccessfully));
          this.fetchDevices();
          this.props.resetList();
        } else {
          this.setState({ unlinkingDeviceId: null, confirmingDeviceId: null });
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp?.status?.statusCode !== "OK" &&
          resp?.status?.statusCode !== "FORBIDDEN" &&
          resp?.status?.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp?.status?.message);
        }
      });
  }

  render() {
    const {
      devices,
      isLoaded,
      confirmingDeviceId,
      unlinkingDeviceId
    } = this.state;

    return (
      <div className="custommodal">
        <div className="custommodalinner">
          <div className="loginpad">
            <h6 className="modal-heading">
              {this.t(T_SERVICE.viewSites.devices.header)}
              {this.props.siteName}
            </h6>
            <Button onClick={this.props.closePopup} className="cancle">
              x
            </Button>
            <hr className="hrpadding" />
            <div className="firstpage">
              <p className="formfont">
                {this.t(T_SERVICE.viewSites.devices.unlinkWarning)}
              </p>
              {(() => {
                if (!isLoaded) {
                  return (
                    <p className="formfont">
                      {this.t(T_SERVICE.viewSites.devices.loading)}
                    </p>
                  );
                }
                if (!devices || devices.length === 0) {
                  return (
                    <div className="table-error">
                      <p>{this.t(T_SERVICE.viewSites.devices.noDevices)}</p>
                    </div>
                  );
                }
                return (
                  <Table className="tablebox">
                    <thead>
                      <tr>
                        <th>
                          {this.t(T_SERVICE.viewSites.devices.serialNumber)}
                        </th>
                        <th>
                          {this.t(T_SERVICE.viewSites.devices.deviceType)}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {devices.map(device => (
                        <tr key={device.id}>
                          <td>{device.serialNumber}</td>
                          <td>{device.deviceType}</td>
                          <td className="tablemodal">
                            <a
                              onClick={() => {
                                if (unlinkingDeviceId === null) {
                                  this.handleUnlinkClick(device.id);
                                }
                              }}
                            >
                              <span className="editbtn delete-link">
                                {unlinkingDeviceId === device.id
                                  ? "..."
                                  : confirmingDeviceId === device.id
                                  ? this.t(
                                      T_SERVICE.viewSites.devices.confirmUnlink
                                    )
                                  : this.t(T_SERVICE.viewSites.devices.unlink)}
                              </span>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                );
              })()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomDevicesModal);
